import {CanDeactivate} from '@angular/router';
import {CreateSourcingMatrixReportComponent} from './create-sourcing-matrix-report.component';
import {Injectable} from '@angular/core';

@Injectable()
export class CreateSourcingMatrixDeactivateGuard implements CanDeactivate<CreateSourcingMatrixReportComponent> {

  canDeactivate(component): Promise<boolean> {
    return component.canDeactivate();
  }
}
